/**
 * I18nDebugBanner — fixed banner shown when `?debug_i18n=1` is in the URL.
 *
 * Helps QA/translators identify they're in debug mode. The banner shows the
 * active language, a quick-reload link to clear debug mode, and instructions
 * for reporting wrong translations.
 */
import React from 'react';
import { useLanguage } from '../context/AppContext';

const I18nDebugBanner = () => {
  const { language, debugI18n } = useLanguage();
  if (!debugI18n) return null;

  const stopUrl = (() => {
    try {
      const u = new URL(window.location.href);
      u.searchParams.delete('debug_i18n');
      return u.toString();
    } catch (_) { return '/'; }
  })();

  return (
    <div
      data-testid="i18n-debug-banner"
      className="fixed top-0 left-0 right-0 z-[9999] bg-yellow-400 text-black text-xs px-3 py-1.5 flex items-center justify-between gap-3 shadow-md font-mono"
      style={{ borderBottom: '2px dashed #000' }}
    >
      <span>
        🔍 <strong>DEBUG i18n</strong> · lang=<strong>{language}</strong> ·
        every string is prefixed by <code>⟦key⟧</code>
      </span>
      <a
        href={stopUrl}
        className="underline font-bold hover:text-red-700"
        data-testid="i18n-debug-stop"
      >
        Stop debug
      </a>
    </div>
  );
};

export default I18nDebugBanner;
